import React, { memo } from "react";

//scss
import "./style.scss";

const SaveClear = memo(({ onSave, onClear, disableSave }) => {
	return (
		<div className="save-clear text-sm-bold">
			<button aria-label="clear-all" className="clear " onClick={onClear}>
				Clear All
			</button>
			<button
				aria-label="save-all"
				className="save clr-white"
				onClick={onSave}
				disabled={disableSave}
			>
				Save
			</button>
		</div>
	);
});

export default SaveClear;
